<div class="button-wrapper">
    <div class="group">
        <button class="extra-button green">
            <img src="assets/ico/save.svg" alt="save" />
        </button>
        <button class="extra-button red">
            <img src="assets/ico/undo.svg" alt="undo" />
        </button>
    </div>
</div>